import SuperFetch from '../helpers/superFetch';

type RequestWithStringParam = (param: any) => Promise<Response>;
type RequestWithNoParam = () => Promise<Response>;

/**
 * Klasa zawiera metody służące wysyłaniu zapytań autentykacyjnych do API
 *
 */
class Auth {
  /** Zapytanie o dane użytkownika */
  whoIAm: RequestWithNoParam = () => SuperFetch.get(`user/who-am-i`);
  /** Przekazanie prośby o odnowienie tokenu */
  refreshToken: RequestWithStringParam = refreshToken => SuperFetch.post(`auth/refresh`, { refreshToken });
  /** ylogowanie z aplikacji */
  logout: RequestWithNoParam = () => SuperFetch.delete(`auth/logout`);
}

export default new Auth();
